import { cn } from '@/context/global/utils/cn';

export type IconVolumeHighProps = {
  className?: string;
  size?: number;
};

export default function IconVolumeHigh({
  className = '',
  size = 32,
}: IconVolumeHighProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-white', className)}
    >
      <path
        d="M2.66699 13.3334V18.6667C2.66699 21.3334 4.00033 22.6667 6.66699 22.6667H8.58699C9.13366 22.6667 9.66699 22.8267 10.1337 23.1067L14.2003 25.64C17.6137 27.7734 20.4003 26.1467 20.4003 22.0934V9.90671C20.4003 5.84004 17.6137 4.22671 14.2003 6.36004L10.1337 8.89337C9.66699 9.17337 9.13366 9.33337 8.58699 9.33337H6.66699C4.00033 9.33337 2.66699 10.6667 2.66699 13.3334Z"
        fill="currentColor"
      />
      <path
        d="M24 10.6667C26.64 13.7867 26.64 18.2134 24 21.3334"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.5332 7.46667C30.7732 12.5067 30.7732 19.4933 26.5332 24.5333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
